import VueRouter from 'vue-router';
import Home from '@/components/Home'
import Plays from '@/components/Plays'
import Play from '@/components/Play'
import Review from '@/components/Review'
import Blogs from '@/components/Blogs'
import Blog from '@/components/Blog'
import Whatson from '@/components/Whatson'
import Getinvolved from '@/components/Getinvolved'
import Previousproductions from '@/components/Previousproductions'
import Auditions from '@/components/Auditions'
import Directorsubmissions from '@/components/Directorsubmissions'
import Backstagecrew from '@/components/Backstagecrew'
import Combinationsnewsletter from '@/components/Combinationsnewsletter'

import Privacy from '@/components/Privacy'
import Terms from '@/components/Terms'
import About from '@/components/About'
import Contact from '@/components/Contact'
import Register from '@/components/accounts/Register'
import Login from '@/components/accounts/Login'
import Account from '@/components/accounts/Account'

import Admin from '@/components/accounts/Admin'
import AdminPlays from '@/components/accounts/AdminPlays'
import AdminPlay from '@/components/accounts/AdminPlay'
import AdminBlogs from '@/components/accounts/AdminBlogs'
import AdminBlog from '@/components/accounts/AdminBlog'
import AdminCastmembers from '@/components/accounts/AdminCastmembers'
import AdminAbout from '@/components/accounts/AdminAbout'
import AdminContact from '@/components/accounts/AdminContact'
import AdminCombinations from '@/components/accounts/AdminCombinations'
import AdminHeroimages from '@/components/accounts/AdminHeroimages'

import PageNotFound from '@/components/PageNotFound'



import store from '../store'

const ifNotAuthenticated = (to, from, next) => {
  console.log("ifNotAuthenticated");
  if (!store.getters.isAuthenticated) {
    console.log("  notAuthenticated");
    if (store.getters.isProfileLoaded) { console.log("  isProfileLoaded"); } else { console.log("  !isProfileLoaded"); }
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  console.log("ifAuthenticated");
  if (store.getters.isAuthenticated) {
    console.log("  isAuthenticated");
    if (store.getters.isProfileLoaded) { console.log("  isProfileLoaded"); } else { console.log("  !isProfileLoaded"); }
    next()
    return
  }
  next('/') // next('/admin-edit-tool/login')
}

const routes = [
    {
        path: '/',
        name:'home',
        component: Home,
    },
    {
        path: '/whats-on',
        name: 'whatson',
        component: Whatson
    },
    {
        path: '/get-involved',
        name: 'getinvolved',
        component: Getinvolved
    },
    {
        path: '/previous-productions',
        name: 'previousproductions',
        component: Previousproductions
    },
    {
        path: '/auditions',
        name: 'auditions',
        component: Auditions
    },
    {
        path: '/director-submissions',
        name: 'directorsubmissions',
        component: Directorsubmissions
    },
    {
        path: '/backstage-crew',
        name: 'backstagecrew',
        component: Backstagecrew
    },
    {
        path: '/combinations',
        name: 'combinations',
        component: Combinationsnewsletter
    },
    {
        path: '/plays',
        name: 'plays',
        component: Plays,
        props: true
    },
    {
        path: '/blogs',
        name: 'blogs',
        component: Blogs,
        props: true
    },
    {
        path: '/blogs/:slug',
        name: 'blog',
        component: Blog,
        props: true
    },
    {
        path: '/blog',
        redirect: '/blogs'
    },
    {
        path: '/privacy-policy',
        name: 'privacy',
        component: Privacy
    },
    {
        path: '/terms',
        name: 'terms',
        component: Terms
    },
    {
        path: '/about',
        name: 'about',
        component: About
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact
    },
    {
        path: '/contact/:preselectSubject',
        name: 'contactWithPreselectedSubject',
        component: Contact,
        props: true
    },
    {
        path: '/admin-edit-tool/register',
        name: 'register',
        component: Register,
        beforeEnter: ifNotAuthenticated,
    },
    {
        path: '/admin-edit-tool/login',
        name: 'login',
        component: Login,
        beforeEnter: ifNotAuthenticated,
    },
    {
        path: '/account',
        name: 'account',
        component: Account,
        beforeEnter: ifAuthenticated, //only authenticated users are allowed to reach this (aka a 'naviguation guard')
    },
    {
        path: '/admin-edit-tool',
        name: 'admin',
        component: Admin,
        beforeEnter: ifAuthenticated, //only authenticated users are allowed to reach this (aka a 'naviguation guard')
    },
    {
        path: '/admin-edit-tool/plays',
        name: 'admin-plays',
        component: AdminPlays,
        beforeEnter: ifAuthenticated, //only authenticated users are allowed to reach this (aka a 'naviguation guard')
    },
    {
        path: '/admin-edit-tool/plays/:slug',
        name: 'admin-play',
        component: AdminPlay,
        beforeEnter: ifAuthenticated, //only authenticated users are allowed to reach this (aka a 'naviguation guard')
        props: true
    },
    {
        path: '/admin-edit-tool/blogs',
        name: 'admin-blogs',
        component: AdminBlogs,
        beforeEnter: ifAuthenticated, //only authenticated users are allowed to reach this (aka a 'naviguation guard')
    },
    {
        path: '/admin-edit-tool/blogs/:slug',
        name: 'admin-blog',
        component: AdminBlog,
        beforeEnter: ifAuthenticated, //only authenticated users are allowed to reach this (aka a 'naviguation guard')
        props: true
    },
    {
        path: '/admin-edit-tool/castmembers',
        name: 'admin-castmembers',
        component: AdminCastmembers,
        beforeEnter: ifAuthenticated, //only authenticated users are allowed to reach this (aka a 'naviguation guard')
    },
    {
        path: '/admin-edit-tool/contact',
        name: 'admin-contact',
        component: AdminContact,
        beforeEnter: ifAuthenticated, //only authenticated users are allowed to reach this (aka a 'naviguation guard')
    },
    {
        path: '/admin-edit-tool/about',
        name: 'admin-about',
        component: AdminAbout,
        beforeEnter: ifAuthenticated, //only authenticated users are allowed to reach this (aka a 'naviguation guard')
    },
    {
        path: '/admin-edit-tool/combinations',
        name: 'admin-combinations',
        component: AdminCombinations,
        beforeEnter: ifAuthenticated, //only authenticated users are allowed to reach this (aka a 'naviguation guard')
    },
    {
        path: '/admin-edit-tool/heroimages',
        name: 'admin-heroimages',
        component: AdminHeroimages,
        beforeEnter: ifAuthenticated, //only authenticated users are allowed to reach this (aka a 'naviguation guard')
    },
    {
        path: '/:slug/reviews/:reviewindex',
        name: 'review',
        component: Review,
        props: true
    },
    {   path: '/404',
        name: '404',
        component: PageNotFound
    },  // The reason I've separated the 404 into 2 routes (this one and the '*' below) is so that you can also programmatically direct the user to the 404 route in such a case when some data you need does not resolve; e.g. by using: return this.$router.push('/404')   
    {
        path: '/:slug',
        name: 'play',
        component: Play,
        props: true
    },
    {
        path: '/:slug/#audition',
        name: 'play-audition',
        component: Play,
        props: true
    },
    { path: '*', redirect: '/404' },  

];



const router = new VueRouter({
    routes,
    mode: 'history', // Removes # from url
    scrollBehavior(to, from, savedPosition) {
        var hashtag = to.hash; // || ("#" + to.path.split('#', 2)[1]);
        if (hashtag) {
            console.log("[scrolling] to hash:",hashtag);
            return {selector: hashtag}
        } else {
            console.log("[scrolling] to top of page");
            return { x: 0, y: 0 } //scroll to top on route change
        }
    },
});

router.beforeEach(function(to, from, next) { //router.beforeEach((to, from, next) => {
    //console.log("router",router.app.$root);
    store.commit('setContentLoaded', false);
    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js